/**
 * Tastaturkürzel-Store — editierbare, persistente Keyboard-Shortcuts.
 * Persistenz: localStorage (pro Gerät/Browser).
 * Wird vom Hook `useKeyboardShortcuts` gelesen und vom Einstellungen-Bereich
 * "Allgemein → Tastaturkürzel" bearbeitet.
 */
const STORAGE_KEY = 'ew_keyboard_shortcuts';
export const SHORTCUTS_UPDATED_EVENT = 'ew:shortcuts-updated';

// Verfügbare Sidebar-Funktionen, die einem Kürzel zugeordnet werden können
export const SHORTCUT_TARGETS = [
  { label: 'Dashboard', path: '/dashboard' },
  { label: 'Adressen', path: '/addresses' },
  { label: 'Leads', path: '/leads' },
  { label: 'Projekte', path: '/projects' },
  { label: 'Aufgaben', path: '/tasks' },
  { label: 'KI-PostManager', path: '/posteingang' },
  { label: 'Kalender', path: '/calendar' },
  { label: 'E-Mails', path: '/emails' },
  { label: 'Aufträge', path: '/orders' },
  { label: 'Buchhaltung', path: '/projects?project_type=Buchhaltung' },
  { label: 'Controlling', path: '/controlling' },
  { label: 'Notizen', path: '/notes' },
  { label: 'Fuhrpark', path: '/fleet' },
  { label: 'KI-Assistent', path: '/ai-assistant' },
  { label: 'Kampagnen', path: '/campaigns' },
  { label: 'Personal', path: '/hr' },
  { label: 'Recruiting', path: '/recruiting' },
  { label: 'EasyWorkChat', path: '/chat' },
  { label: 'Einstellungen', path: '/settings' },
];

// Standard-Kürzel (Auslieferungszustand)
export const DEFAULT_SHORTCUTS = [
  { id: 'sc-tasks',     label: 'Aufgaben',    path: '/tasks',     key: 't', ctrl: false, alt: false, shift: false },
  { id: 'sc-calendar',  label: 'Kalender',    path: '/calendar',  key: 'k', ctrl: false, alt: false, shift: false },
  { id: 'sc-addresses', label: 'Adressen',    path: '/addresses', key: 'a', ctrl: true,  alt: false, shift: false },
  { id: 'sc-projects',  label: 'Projektliste',path: '/projects',  key: 'p', ctrl: true,  alt: false, shift: false },
  { id: 'sc-emails',    label: 'E-Mails',     path: '/emails',    key: 'e', ctrl: true,  alt: false, shift: false },
  { id: 'sc-cal-ctrl',  label: 'Kalender',    path: '/calendar',  key: 'k', ctrl: true,  alt: false, shift: false },
  { id: 'sc-fleet',     label: 'Fahrtenbuch', path: '/fleet?section=logbook', key: 'f', ctrl: true, alt: true, shift: false, state: { openNewTrip: true } },
  { id: 'sc-notes',     label: 'Neue Notiz',  path: '/notes',     key: 'n', ctrl: true,  alt: true,  shift: false, state: { openNew: true } },
  { id: 'sc-posteingang', label: 'KI-Posteingang', path: '/posteingang', key: 'p', ctrl: true, alt: true, shift: false },
];

export function loadShortcuts() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.filter((s) => s && s.key && s.path);
    }
  } catch { /* ignore */ }
  return DEFAULT_SHORTCUTS.map((s) => ({ ...s }));
}

export function saveShortcuts(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent(SHORTCUTS_UPDATED_EVENT));
  } catch { /* ignore */ }
}

export function resetShortcuts() {
  saveShortcuts(DEFAULT_SHORTCUTS.map((s) => ({ ...s })));
  return DEFAULT_SHORTCUTS.map((s) => ({ ...s }));
}

/** Lesbare Anzeige eines Kürzels, z.B. "STRG+ALT+N" oder "T" */
export function formatCombo(s) {
  const parts = [];
  if (s.ctrl) parts.push('STRG');
  if (s.alt) parts.push('ALT');
  if (s.shift) parts.push('SHIFT');
  parts.push((s.key || '').toUpperCase());
  return parts.join('+');
}

/** Prüft, ob zwei Kürzel dieselbe Tastenkombination belegen */
export function isSameCombo(a, b) {
  return !!a.ctrl === !!b.ctrl && !!a.alt === !!b.alt && !!a.shift === !!b.shift
    && (a.key || '').toLowerCase() === (b.key || '').toLowerCase();
}
